import { render, staticRenderFns } from "./AddBankInfo.vue?vue&type=template&id=db6de418&scoped=true"
import script from "./AddBankInfo.vue?vue&type=script&lang=js"
export * from "./AddBankInfo.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/banking_information.css?vue&type=style&index=0&id=db6de418&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6de418",
  null
  
)

export default component.exports